import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';

const styles = {
  root: {
    flex: 1,
    color: "#fff",
    fontWeight: 300,
  },
  title: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    margin: '0px',
    fontWeight: '400',
    fontSize: '1.25rem',
    marginLeft: '3px'
  }
};

const PageTitle = ({ title, classes, color }) => (
  <Hidden mdDown>
    <p className={classes.title}>{title}</p>
  </Hidden>
);

PageTitle.propTypes = {
  title: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  color: PropTypes.string
};

export default withStyles(styles)(PageTitle);